import { dateStrFormatRegex } from './regex';

// Validate that two dates are in the correct order.
const dateOrderValidation = (startDateStr, endDateStr) => {
	if (!startDateStr || !endDateStr) {
		return undefined;
	}
	if (!startDateStr.match(dateStrFormatRegex) || !endDateStr.match(dateStrFormatRegex)) {
		return 'Invalid date format. Please use MM/DD/YYYY';
	}
	const startDateArr = startDateStr.split('-');
	// Subtract 1 from month because months in Date objects are 0-based
	const startDate = new Date(startDateArr[0], startDateArr[1] - 1, startDateArr[2]);
	// Without setFullYear, the Date constructor assumes any 2-digit years are in the 1900s.
	startDate.setFullYear(startDateArr[0]);

	const endDateArr = endDateStr.split('-');
	// Subtract 1 from month because months in Date objects are 0-based
	const endDate = new Date(endDateArr[0], endDateArr[1] - 1, endDateArr[2]);
	// Without setFullYear, the Date constructor assumes any 2-digit years are in the 1900s.
	endDate.setFullYear(endDateArr[0]);
	return startDate < endDate ? undefined : 'Start date must be before end date';
};

export default dateOrderValidation;
